'use client'

// Next Imports
import Link from 'next/link'

// Third-party Imports
import classnames from 'classnames'

// Util Imports
import { horizontalLayoutClasses } from '@layouts/utils/layoutClasses'

const FooterContent = () => {
  return (
    <div
      className={classnames(horizontalLayoutClasses.footerContent, 'flex items-center justify-between flex-wrap gap-4')}
    >
      <p>
        <span className='text-textSecondary'>{`© ${new Date().getFullYear()}, Hecho con `}</span>
        <span>{`❤️`}</span>
        <span className='text-textSecondary'>{` por `}</span>
        <Link href='https://www.bama.mx' target='_blank' className='text-primary uppercase'>
          BAMA
        </Link>
      </p>
    </div>
  )
}

export default FooterContent
